module.exports = __webpack_public_path__ + "img/upload.016ff408.png";